import { JSONResponse } from '../Types/Types'
import { requestJSON } from './REST/RESTClient'
import { acceptTermsOfServiceURL, rejectTermsOfServiceURL } from '../../constants/ApiConstants'
import { RESTMethods } from '../../constants/REST'

/**
 * Accept terms of service for the current user.
 */
export const acceptTermsOfService = (): Promise<JSONResponse<void>> =>
    requestJSON(acceptTermsOfServiceURL, {
        method: RESTMethods.PUT,
        errorOnNoContent: false
    })
/**
 * Reject terms of service for current user.
 */
export const rejectTermsOfService = (): Promise<JSONResponse<void>> =>
    requestJSON(rejectTermsOfServiceURL, {
        method: RESTMethods.GET,
        errorOnNoContent: false
    })
